import { render, staticRenderFns } from "./ClicCheckbox.vue?vue&type=template&id=55279cb8&"
import script from "./ClicCheckbox.vue?vue&type=script&lang=js&"
export * from "./ClicCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports